module.exports = __webpack_public_path__ + "static/media/mod-iptelephony.b724c20b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/mod-iptelephony.jpg
// module id = 335
// module chunks = 0